import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { HeaderImage } from '../../common/header-image/header-image';
import styles from './header-image.module.css';

function HomeHeaderImage() {
  return (
    <div
      className="snf-lx-components-home-header-image-header-image"
      style={{ display: 'contents' }}
    >
      <HeaderImage
        url="/images/homepage.png"
        backgroundColor="var(--var-color-gradient-dark)"
        height={{
          xs: '100vw',
          sm: '60vw',
          md: '45vw',
          lg: '40vw'
        }}
        topBgImage="linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6))"
        maxHeight={{ md: '42.5rem' }}
      >
        <div className="padding-mobile d-flex flex-column flex-md-row justify-content-end justify-content-md-between align-items-md-end h-100 p-5 p-md-5 text-white">
          <div>
            <div className="snf-font-w6 snf-font-18 snf-font-md-28 mb-2">
              <FormattedMessage
                defaultMessage="La trasformazione digitale"
                description="Home header image - title"
              />
            </div>
            <div className="row">
              <div className="col-12 col-md-5 col-lg-4 p-0">
                <div className="mb-3 mb-md-4 font-weight-light snf-font-20">
                  <FormattedMessage
                    defaultMessage="Consulenza, cloud e dati per accompagnare pubblica amministrazione, banche e imprese nella crescita resiliente e sostenibile."
                    description="Home header image - description"
                  />
                </div>
              </div>
            </div>
            <div>
              <Link to="/azienda">
                <button
                  type="button"
                  className={`btn text-white rounded-0 snf-font-w6 px-3 mt-md-1 ${
                    styles.headerImageButton
                  }`}
                >
                  <FormattedMessage
                    defaultMessage="Scopri di più"
                    description="Home header image - scopri di più"
                  />
                </button>
              </Link>
            </div>
          </div>

          <div className="row mt-3 my-md-0">
            <div className="col-8 col-md-12 p-0">
              <img
                className="mw-100 img-opacity"
                src="/images/logo-sistemi-expanded.svg"
                alt="Logo Sistemi Informativi"
                width="253"
                height="auto"
              />
            </div>
          </div>
        </div>
      </HeaderImage>
    </div>
  );
}

HomeHeaderImage.displayName = 'HomeHeaderImage';
export { HomeHeaderImage };
